<zef-dialog
  [open]="state.open"
  [autoFocus]="false"
  [options]="{
    maxHeight: '80vh',
    maxWidth: '900px',
    width: '95vw',
    disableClose: true
  }">
  <div
    class="__content"
    [class.is-dark-theme]="state.isDarkTheme">

    @if (state.open) {
      <zui-code-field
        class="__code-field"
        [ngrxFormControlState]="state.formState?.controls.yaml"
        [ngrxEnableFocusTracking]="true"
        [editorOptions]="{
          quickSuggestions: {
            other: true,
            comments: false,
            strings: true
          }
        }"
        [editorModel]="{
          language: 'yaml',
          fileName: 'zerops-import'
        }"
      />
    }

    <div class="__buttons">
      <div class="fx:grid  __buttons-grid">

        <div>

          <button
            type="button"
            class="__close-button  __major-button"
            (click)="onClose$.next()"
            mat-flat-button>
            Close
          </button>
        </div>

        <div class="fx:text-right">

          @if (state.mode === modes.Import) {

            @if (state.entity === dialogEntities.Project) {
              <button
                (click)="templatesPopRef.open()"
                [satPopoverAnchor]="templatesPopRef"
                mat-button
                type="button"
                class="c-button--smaller">
                <mat-icon>expand_more</mat-icon>&nbsp;<span>Select a template</span>
              </button>
            }

            @if (state.entity === dialogEntities.ServiceStack && getServiceUtilityRecipes().length > 0) {
              <button
                (click)="templatesPopRef.open()"
                [satPopoverAnchor]="templatesPopRef"
                mat-button
                type="button"
                class="c-button--smaller">
                <mat-icon>expand_more</mat-icon>&nbsp;<span>Select a service template</span>
              </button>
            }

            <button
              mat-button
              (click)="copy(state.formState?.controls.yaml?.value)"
              color="accent"
              type="button"
              class="c-button--smaller  fx:mr-0-5">
              <mat-icon>content_copy</mat-icon>&nbsp;<span>Copy to clipboard</span>
            </button>

            <zui-separator
              class="__utility-separator  fx:pl-0-5  fx:pr-0-75"
              [size]="'small'"
              [spacing]="'none'"
              [orientation]="'horizontal'"
            />
          }

          <!-- read-only members get no toggle at all: they cannot export decrypted
               secrets, so offering it would only fail on re-authorization -->
          @if ((!state.mode || state.mode === modes.Export) && state.exportId && state.canRevealSecrets) {
            <span class="__reveal-toggle  fx:align-middle  fx:mr-0-75">
              <mat-slide-toggle
                [checked]="state.reveal"
                [disabled]="state.exporting"
                (change)="onToggleReveal$.next($event.checked)">
                Reveal secret values
              </mat-slide-toggle>
              @if (state.exporting) {
                <zui-three-dots class="__reveal-loading  fx:align-middle  fx:ml-0-5" />
              }
            </span>
          }

          @if (!!state.yaml && (!state.mode || state.mode === modes.Export)) {
            <button
              class="__major-button  __copy-button"
              mat-button
              color="accent"
              type="button"
              (click)="copy(state.formState?.controls.yaml?.value); onClose$.next()">
              <strong>Copy to clipboard and close</strong>&nbsp;<mat-icon class="__content-copy-icon">content_copy</mat-icon>
            </button>
          }

          @if (state.mode === modes.Import) {
            <zef-progress-error
              popVerticalAlign="above"
              [key]="state.entity === dialogEntities.Project ? projectImportKey : serviceStackImportKey"
              class="__newsletter-button"
            >
              <button
                mat-flat-button
                color="accent"
                type="type"
                class="c-button--full __major-button  __major-button--icon-right __primary-button"
                (click)="state.entity === dialogEntities.Project ? onProjectImport$.next() : onServiceStackImport$.next()">
                <span>Import {{ state.entity ===  dialogEntities.Project ? 'project' : 'service' }}</span>&nbsp;<mat-icon fontSet="material-icons-outlined">play_arrow</mat-icon>
              </button>
            </zef-progress-error>
        }
    </div>

      </div>
    </div>

  </div>
</zef-dialog>

<sat-popover
  #templatesPopRef
  [autoFocus]="false"
  [restoreFocus]="false"
  hasBackdrop
  (backdropClicked)="templatesPopRef.close()"
  [verticalAlign]="'below'"
  [horizontalAlign]="'center'">
  <mat-card class="__templates-pop-card  z-manual-elevation  c-soft-elevation">
    <zef-scrollbar
      class="__templates-scrollbar"
      maxHeight="60vh">
      <mat-action-list class="__templates-action-list" dense>

        <!-- Enhanced Loading States -->
        @if (recipeLoadingState().isInitialLoading) {
          <!-- Loading State -->
          <div class="recipes-loading">
            <zui-three-dots />
            <p>Loading recipes ...</p>
          </div>
        } @else if (recipeLoadingState().isEmpty) {
          <!-- No Recipes Available -->
          <div class="recipes-empty fx:text-center fx:py-2">
            <mat-icon class="fx:text-muted">inventory_2</mat-icon>
            <p class="fx:mt-1">No templates available</p>
          </div>
        } @else {
          <!-- Success State - Show recipes -->
          <div class="fx:relative">

            @if (recipeLoadingState().isSubsequentLoading) {
              <!-- Subsequent Loading Overlay -->
              <div class="recipes-subsequent-loading">
                <zui-three-dots />
                <span>Updating templates ...</span>
              </div>
            }

          @if (state.entity === dialogEntities.ServiceStack) {
            <!-- Service Import: Flat list of service utility recipes -->

            <div mat-subheader>Open Source Apps and Software</div>
            @if (getServiceUtilityRecipes().length === 0) {
              <div class="__no-options">No templates available</div>
            }

            @for (recipe of getServiceUtilityRecipes(); track recipe.id) {
              @if (recipe.environments && recipe.environments.length > 1) {
                <!-- Multiple environments - show submenu -->
                <button
                  mat-list-item
                  [matMenuTriggerFor]="envMenu"
                  type="button"
                  class="__recipe-menu-trigger">
                  <zui-action-list-item
                    class="__templates-action-list-item"
                    [mode]="'dense'"
                    [imageUrl]="recipeIconUrlMap()[recipe.slug]"
                    [svgIcon]="recipe.icon"
                    [iconFaded]="false"
                    [label]="recipe.name"
                  />
                  <mat-icon class="environment-arrow">arrow_forward</mat-icon>
                </button>

                <mat-menu #envMenu="matMenu" class="__environment-menu">
                  @for (env of recipe.environments; track env.name) {
                    <button mat-menu-item (click)="onSelectRecipeEnvironment(env); templatesPopRef.close()" class="__environment-menu-item">
                      {{ env.name }}
                    </button>
                  }
                </mat-menu>
              } @else {
                <!-- Single environment - direct selection -->
                <button
                  mat-list-item
                  (click)="onSelectRecipe(recipe); templatesPopRef.close()"
                  type="button">
                  <zui-action-list-item
                    class="__templates-action-list-item"
                    [mode]="'dense'"
                    [imageUrl]="recipeIconUrlMap()[recipe.slug]"
                    [svgIcon]="recipe.icon"
                    [iconFaded]="false"
                    [label]="recipe.name"
                  />
                </button>
              }
            }
          } @else {
            <!-- Project Import: Categorized recipe list -->
            @for (type of importDialogTypes; track type.type) {

              <div mat-subheader>{{ type.name }}</div>
              @if (getRecipesForType(type.type).length === 0) {
                <div class="__no-options">No templates available</div>
              }

              @for (recipe of getRecipesForType(type.type); track recipe.id) {
                @if (recipe.environments && recipe.environments.length > 1) {
                  <!-- Multiple environments - show submenu -->
                  <button
                    mat-list-item
                    [matMenuTriggerFor]="envMenu"
                    type="button"
                    class="__recipe-menu-trigger">
                    <zui-action-list-item
                      class="__templates-action-list-item"
                      [mode]="'dense'"
                      [imageUrl]="recipeIconUrlMap()[recipe.slug]"
                      [svgIcon]="recipe.icon"
                      [iconFaded]="false"
                      [label]="recipe.name"
                    />
                    <mat-icon class="environment-arrow">arrow_forward</mat-icon>
                  </button>

                  <mat-menu #envMenu="matMenu" class="__environment-menu">
                    @for (env of recipe.environments; track env.name) {
                      <button mat-menu-item (click)="onSelectRecipeEnvironment(env); templatesPopRef.close()" class="__environment-menu-item">
                        {{ env.name }}
                      </button>
                    }
                  </mat-menu>
                } @else {
                  <!-- Single environment - direct selection -->
                  <button
                    mat-list-item
                    (click)="onSelectRecipe(recipe); templatesPopRef.close()"
                    type="button">
                    <zui-action-list-item
                      class="__templates-action-list-item"
                      [mode]="'dense'"
                      [imageUrl]="recipeIconUrlMap()[recipe.slug]"
                      [svgIcon]="recipe.icon"
                      [iconFaded]="false"
                      [label]="recipe.name"
                    />
                  </button>
                }
              }
            }
          }

          </div>
        }

      </mat-action-list>
    </zef-scrollbar>
  </mat-card>
</sat-popover>
